export enum LoadingVariant {
  Default = 'default',
  Compact = 'compact',
}

export interface LoadingProps {
  /** Use compact variant for inline card display */
  variant?: LoadingVariant;
  /** Per-card generation start time (overrides global store) */
  startTime?: number;
  /** Per-card media type override ('image' | 'video') */
  mediaTypeOverride?: 'image' | 'video';
}
